import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './BottomNav.css';

const BottomNav = () => {
  const { pathname } = useLocation();

  return (
    <div className="m-bottom-nav">
      <Link to="/" className={`m-nav-item${pathname === '/' ? ' active' : ''}`}>
        <div className="m-nav-icon">🏠</div>
        <div className="m-nav-label">Home</div>
      </Link>
      <Link to="/services" className={`m-nav-item${pathname === '/services' ? ' active' : ''}`}>
        <div className="m-nav-icon">🗺️</div>
        <div className="m-nav-label">Services</div>
      </Link>
      <Link to="/services" className="m-nav-book">
        <div className="m-book-btn">🚕</div>
        <div className="m-book-label">Book</div>
      </Link>
      <Link to="#" className={`m-nav-item${pathname === '/my-trips' ? ' active' : ''}`}>
        <div className="m-nav-icon">📋</div>
        <div className="m-nav-label">My Trips</div>
      </Link>
      <Link to="#" className={`m-nav-item${pathname === '/profile' ? ' active' : ''}`}>
        <div className="m-nav-icon">👤</div>
        <div className="m-nav-label">Profile</div>
      </Link>
    </div>
  );
};

export default BottomNav;
